import type { TextualDisplay } from "@ebay/experience-types-ebay";

export type Input = {
  readonly class?: string | (string | { [key: string]: boolean })[];
  readonly "data-testid"?: string;
  readonly disabled?: boolean;
  readonly id?: string;
  readonly model?: TextualDisplay | string;
  readonly noTag?: boolean;
  readonly span?: boolean;
  readonly tag?: string;

  readonly "on-click"?: () => void;
};

export default class extends Marko.Component<Input> {
  handleClick() {
    this.emit("click");
  }
}
